<template>
	<div>
		<!-- 头部 -->
		<!--  <div class="top">

        </div> -->
		<headView @getLoginShow="getLoginShow" :loginShow="loginShow"></headView>
		<!-- /personal/index -->
		<!-- 搜索 -->
		<search @getLoginShow="getLoginShow" :is-lock-search="isLockSearch"  v-if="!isShow" ref="searchRef"></search>
		<!-- 导航 -->
		<navbar :getSchoolName="getSchoolName"></navbar>
		<!-- <personal v-show="isShow"></personal> -->
		<!-- <navbar :getSchoolName="getSchoolName" v-if="!isShow"></navbar> -->
		<!-- 中间部分 -->
		<!-- <allcontent v-show="this.actName == 'first'"></allcontent> -->
		<!-- <div style="height: 70px;" v-show="this.actName !== 'first'"></div> -->
		<!-- 底部 -->

		<!-- <footers v-show="actName == '/allcontent'"></footers> -->
		<!-- <div style="border: 1px solid;font-size: 24px;">首页测试</div> -->
	</div>
</template>

<script>
	import headView from '@/views/headView.vue';
	import search from '@/views/search.vue';
	import navbar from '@/views/navbar.vue';
	import footers from '@/views/footers.vue';
	import {
		getBannerList,
	} from '@/api/api.js';
	export default {
		components: {
			headView,
			search,
			navbar,
			// allcontent,
			footers
		},
		watch: {
			$route(to, from) {
				// this.$router.go(0);
				// console.log('当前页面路由：' + to.path);
				// if (to.path == '/expert/wisdom' || to.path == '/expert/expertDetail' || to.path == '/famous/school' ||
				//     to.path == '/famous/schoolDetail' || to.path == '/training/zone' || to.path == '/training/detail' ||
				//     to.path == '/activity/index' || to.path == '/activity/information' || to.path ==
				//     '/activity/payment' || to.path == '/activity/paymentSuccess' || to.path ==
				//     '/activity/paymentFail' || to.path == '/broadcast/index' || to.path == '/activity/activityDetail' ||
				//     to.path == '/collect/index') {
				//     this.isShow = false;
				// } else if (this.$route.path == '/allcontent') {
				//     this.isShow = false;
				// } else {
				//     this.isShow = true;
				// }
				if (this.$route.fullPath.indexOf("/personal/") != -1) {
					this.isShow = true;
				} else if (this.$route.path == '/allcontent') {
					this.isShow = false;
				} else {
					this.isShow = false;
				}
				let searchType = this.$refs.searchRef.getSearchType();
				if(window.location.pathname!='/expert/wisdom' && searchType=='1') {
					this.isLockSearch = true;
				}else{
					this.isLockSearch = false;
				}

			},
		},
		data() {
			return {
				actName: '/allcontent',
				isShow: false,
				loginShow: false,
				advertisementShow: false,
				swiperList: {},
				isLockSearch: false
			}
		},
		created() {
			// this.getInfos();
			// console.log(this.$route.fullPath, 'this.$route.fullPath')
			if (this.$route.fullPath.indexOf("/personal/") != -1) {
				this.isShow = true;
			}
			
			
		},
		mounted() {
			let searchType = this.$refs.searchRef.getSearchType();
			if(window.location.pathname!='/expert/wisdom' && searchType=='1') {
				this.isLockSearch = true;
			}else{
				this.isLockSearch = false;
			}
		},
		methods: {
			getLoginShow(e) {
				this.loginShow = e;
			},
			getSchoolName(name) {
				this.actName = name;
			},
		}
	}
</script>

<style scoped>
	.top {
		/* height: 36px;background-color: #f5f5f5; */
	}

	/* /deep/ .el-dialog__header {
		padding: 0 !important;
	}
	
	/deep/ .el-dialog__body{
		padding: 0 !important;
	} */

</style>